import React from "react";
import { useDispatch } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Box, Button, TextField, Typography } from "@mui/material";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CSSProperties } from "@mui/styles";
import clsx from "clsx";
import { isLogin } from "src/app-redux/auth/authSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import NJSLogo from "src/assets/images/tfg_mainlogo.svg";
import CommonButton from "src/components/CommonButton/CommonButton";
import AddTitleToBroswerTab from "src/components/molecules/AddTitleToBroswerTab";

const mediumText: CSSProperties = {
  fontWeight: 500,
} as const;
const semiBoldText: CSSProperties = {
  fontWeight: 600,
} as const;

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    loginButton: {
      backgroundColor: "#72CA00 !important",
      color: "#ffffff",
      width: "100%",
      marginTop: "80px",
      fontSize: "12px",
      textTransform: "unset",
      boxShadow: "none",
    },

    footNote: {
      fontSize: "12px",
      color: "#96A4B9",
      margin: "auto",
      display: "block",
      maxWidth: "320px",
    },
    headNote: {
      display: "block",
      margin: "25px 0",
      fontSize: "12px",
      color: "#292929",
    },
    headerWrap: {
      display: "flex",
      alignItems: "center",
    },
    backButton: {
      minWidth: "45px",
      marginLeft: "-45px",
      padding: "0",
      justifyContent: "start",
      backgroundColor: "transparent !important",
    },
    headerLogo: {
      textAlign: "center",
    },
    headerLogoLink: {
      textAlign: "center",
      width: "100%",
      float: "left",
    },
  })
);
export function ForgotPassword() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useAppSelector(isLogin);
  const [email, setEmail] = React.useState<string>("");
  const sendLink = async () => {
    const parentUrl = process.env.REACT_APP_API_URL;
    const data = {
      email: email,
    };
    try {
      const res = await fetch(`${parentUrl}forgot-user-password`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      if (res.status === 200) {
        dispatch(
          addNotificationAction({
            message: "You will shortly receive an email",
            options: { variant: "success" },
          })
        );
        setEmail('');
      } else {
        throw new Error(res.statusText);
      }
    } catch (error: any) {
      console.log(error);
    }
  };
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return user ? (
    <Redirect to={{ pathname: "/" }} />
  ) : (
    <div className="forgot-password-page">
      <AddTitleToBroswerTab title={"TFG | Portal | Forgot Password"} />
      <div className="left-section">
        <div className="inner">
          <Box my={2} className="headerLogo" textAlign="center">
            <a href="/" className="headerLogoLink">
              <img src={NJSLogo} alt="logo" width="200" />
            </a>
          </Box>
          <div className="form-wrapper">
            <div className={clsx(classes.headerWrap)}>
              <Button component={Link} to="/auth/login" className={clsx(classes.backButton)}>
                <ArrowBackIcon></ArrowBackIcon>
              </Button>
              <h2 className="form-heading">Forgot your password?</h2>
            </div>
            <Typography
              component="span"
              variant="body1"
              color="textPrimary"
              style={semiBoldText}
              className={clsx(classes.headNote)}
            >
              Enter your email address and we&apos;ll send you a link to get back into your account
            </Typography>
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              // type="email"
              InputLabelProps={{
                shrink: true,
              }}
              label=" Email address"
              name="email"
              // placeholder="myemail@address.com"
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
            />
            <Box mt={4}>
              <CommonButton
                disable={!email.match(validRegex)}
                isGreen
                onClick={() => sendLink()}
                style={{ width: "100%" }}
              >
                Send Log in Link
              </CommonButton>
            </Box>
          </div>
          <Typography
            component="span"
            variant="body1"
            color="textPrimary"
            style={mediumText}
            className={clsx(classes.footNote)}
          >
            Copyright©, The Facilities Group, {new Date().getFullYear()}
          </Typography>
        </div>
      </div>
      <div className="right-section">
        <div className="login-bg-pattern"></div>
      </div>
    </div>
  );
}
